import { BaseEntity } from "yt-ng-framework";

export class Izvod extends BaseEntity{
    constructor(){
        super();
    }

    PodVrstaDokumentaStavkaID: number = null;
    // BankaID: number = null;
    Broj: string = null;
    Datum: Date = null;
    Url: string = null;
    BrojDokumenta: string = null;

    Deserialize(input: any){
        super.Deserialize(input);
        this.ID = input.ID;
        this.PodVrstaDokumentaStavkaID = input.PodVrstaDokumentaStavkaID;
        this.Broj = input.Broj;
        this.Datum = input.Datum;    
        // this.BankaID=input.BankaID;
        this.BrojDokumenta = input.BrojDokumenta;
        return this;
    }

    Serialize(input: Izvod){
        return input;
    }

    GetInstance(){
        return this;
    }
}